import { Trans } from '@lingui/react'
import { IconInfo } from '@redteclab/icons'
import { type FC } from 'react'

import 'views/components/organisms/VolumePricingModal/VolumePricingModal.scss'

import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

const VolumePricingModalNotification: FC = () => {
  return (
    <div className="o-VolumePricingModalNotification">
      <div>
        <span className="o-VolumePricingModalNotification__icon--background">
          <IconInfo className="o-VolumePricingModalNotification__icon" />
        </span>
      </div>
      <div className="VolumePricingModalNotification__content">
        <h3 className="VolumePricingModalNotification__content--title">
          <Trans id="volumePricing.modal.notification.title" />
        </h3>
        <span className="rebranding VolumePricingModalNotification__text">
          <Trans id="volumePricing.modal.notification.content" />
        </span>
      </div>
    </div>
  )
}

export default withShopAndRuntimeConfig(VolumePricingModalNotification)
